/* eslint-disable import/no-anonymous-default-export */
import React from 'react';

import { AdminSettingsContext } from './AdminSettingsContext';

const useGeneralSettingsContext = () => React.useContext(AdminSettingsContext);

export { useGeneralSettingsContext };
